// extracted by mini-css-extract-plugin
module.exports = {"accountInformation_body":"AccountInformation_accountInformation_body__3gSrt","ant-descriptions-item-label":"AccountInformation_ant-descriptions-item-label__1d1_I"};